import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import model               from '@widesk-core/decorators/model';

@doc.path('/content_to_publish_statuses/{?id}')
@model.cacheDuration()
abstract class AbstractContentToPublishStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_ContentToPublishStatusReference;
}

export default AbstractContentToPublishStatusModel;
